import { IConfig } from '@cian/config/shared';
import { IMultiPostingPlatformsByRegion } from '../../../../../../shared/redux/types/multiPosting/types';

export const getImportantPlatforms = (config: IConfig, experimentGroup: string, regionId: number) => {
  const multiPostingPlatforms =
    config.get<IMultiPostingPlatformsByRegion>('addformConfig.multiPosting.platforms') || {};

  if (!regionId || !multiPostingPlatforms[regionId]) {
    return [];
  }

  const regionData = multiPostingPlatforms[regionId];
  if (experimentGroup === 'B' && regionData.important) {
    return regionData.important;
  } else if (experimentGroup === 'C' && regionData.importantFree) {
    return regionData.importantFree;
  }

  return [];
};
